<template>
    <div class="connected-channels-section">
        <v-expansion-panels flat v-model="expanded" multiple>
            <v-expansion-panel>
                <v-expansion-panel-header class="section-header">
                    <div class="section-header-content">
                        <h2 class="section-title">Каналы отправки</h2>
                        <div class="header-actions">
                            <v-icon color="mainNew" class="mr-2" @click.stop="refreshChannels">mdi-refresh</v-icon>
                        </div>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div class="section-content">
                        <div v-if="channels.length === 0" class="empty-state">
                            <p>Нет подключенных каналов</p>
                        </div>
                        <div v-else class="channels-list">
                            <div
                                v-for="channel in channels"
                                :key="channel.id"
                                class="channel-card"
                            >
                                <div class="channel-header">
                                    <div class="channel-info">
                                        <div class="channel-icon-wrapper">
                                            <img
                                                v-if="getChannelLogo(channel.type)"
                                                :src="getChannelLogo(channel.type)"
                                                :alt="channel.type"
                                                class="channel-icon-img"
                                            />
                                            <div
                                                v-else
                                                class="channel-icon"
                                                :class="getChannelIconClass(channel.type)"
                                            >
                                                <span v-if="channel.type === 'YCLIENTS'">YC</span>
                                                <span v-else-if="channel.type === 'MAX'">M</span>
                                                <span v-else>{{ channel.type.charAt(0) }}</span>
                                            </div>
                                        </div>
                                    <div class="channel-details">
                                        <div class="channel-name">
                                            {{ channel.name || channel.type }}
                                            <span v-if="channel.phone" class="channel-phone">({{ channel.phone }})</span>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div class="channel-toggles">
                                    <div class="toggle-item">
                                        <v-switch
                                            hide-details
                                            :input-value="channel.defaultForNotifications"
                                            @change="toggleDefault(channel, 'notifications', $event)"
                                        ></v-switch>
                                        <span class="toggle-label">
                                            Использовать этот шаблон по умолчанию для уведомлений
                                        </span>
                                        <v-icon small color="grey" class="help-icon">mdi-help-circle-outline</v-icon>
                                    </div>
                                    <div class="toggle-item">
                                        <v-switch
                                            hide-details
                                            :input-value="channel.defaultForMailings"
                                            @change="toggleDefault(channel, 'mailings', $event)"
                                        ></v-switch>
                                        <span class="toggle-label">
                                            Использовать этот шаблон по умолчанию для рассылок
                                        </span>
                                        <v-icon small color="grey" class="help-icon">mdi-help-circle-outline</v-icon>
                                    </div>
                                    <div class="toggle-item">
                                        <v-switch
                                            hide-details
                                            :input-value="channel.defaultForCrmMessages"
                                            @change="toggleDefault(channel, 'crmMessages', $event)"
                                        ></v-switch>
                                        <span class="toggle-label">
                                            Использовать эту схему по умолчанию для сообщений из CRM
                                        </span>
                                        <v-icon small color="grey" class="help-icon">mdi-help-circle-outline</v-icon>
                                    </div>
                                </div>
                                <div v-if="!channel.connected" class="channel-connect">
                                    <v-btn
                                        small
                                        outlined
                                        color="mainNew"
                                        @click="$emit('connect-channel', channel)"
                                    >
                                        подключить
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
export default {
    name: 'ConnectedChannelsSection',
    props: {
        channels: {
            type: Array,
            required: true,
        },
    },
    data: () => ({
        expanded: [0],
    }),
    methods: {
        getChannelLogo(type) {
            const logoMap = {
                MAX: require('@/assets/img/messenger-logo/max-logo.png'),
                Telegram: require('@/assets/img/messenger-logo/telegram-logo.png'),
                WhatsApp: require('@/assets/img/messenger-logo/wa-logo.png'),
                YCLIENTS: null, // Используем fallback с иконкой
            }
            return logoMap[type] !== undefined ? logoMap[type] : null
        },
        getChannelIconClass(type) {
            const classMap = {
                YCLIENTS: 'channel-icon-yclients',
                MAX: 'channel-icon-max',
                Telegram: 'channel-icon-telegram',
                WhatsApp: 'channel-icon-whatsapp',
            }
            return classMap[type] || 'channel-icon-default'
        },
        toggleDefault(channel, type, value) {
            // Эмитим событие наверх для глобального управления
            this.$emit('toggle-default', {
                source: 'channel',
                sourceId: channel.id,
                type: type,
                value: value,
            })
        },
        refreshChannels() {
            this.$emit('refresh')
        },
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.connected-channels-section
    background: white
    border-radius: 8px
    padding: 16px

.section-header
    padding: 0 !important

.section-header-content
    display: flex
    justify-content: space-between
    align-items: center
    width: 100%

.header-actions
    display: flex
    align-items: center

.section-title
    font-size: 18px
    font-weight: 500
    margin: 0

.section-content
    padding: 24px 0

.channels-list
    display: flex
    flex-direction: column
    gap: 24px

.channel-card
    display: flex
    flex-direction: column
    padding: 20px
    border: 1px solid #E0E0E0
    border-radius: 8px
    background: #FAFAFA

.channel-header
    margin-bottom: 20px

.channel-info
    display: flex
    align-items: center
    gap: 16px

.channel-icon-wrapper
    width: 40px
    height: 40px
    flex-shrink: 0
    display: flex
    align-items: center
    justify-content: center

.channel-icon-img
    width: 40px
    height: 40px
    object-fit: contain

.channel-icon
    width: 40px
    height: 40px
    border-radius: 50%
    display: flex
    align-items: center
    justify-content: center
    color: white
    font-weight: bold
    font-size: 14px

.channel-icon-yclients
    background: #FFC107

.channel-icon-max
    background: #9C27B0

.channel-icon-telegram
    background: #2196F3

.channel-icon-whatsapp
    background: #25D366

.channel-icon-default
    background: #7F8997

.channel-details
    display: flex
    flex-direction: column
    flex: 1

.channel-name
    font-size: 16px
    font-weight: 500
    color: #2A3B51

.channel-phone
    font-size: 14px
    color: #7F8997
    font-weight: normal

.channel-toggles
    display: flex
    flex-direction: column
    gap: 16px
    margin-bottom: 16px

.toggle-item
    display: flex
    align-items: center
    gap: 12px

.toggle-label
    font-size: 14px
    color: #2A3B51
    flex: 1

.help-icon
    cursor: help
    opacity: 0.6

.channel-connect
    margin-top: 12px
    padding-top: 12px
    border-top: 1px solid #E0E0E0

.empty-state
    text-align: center
    padding: 40px
    color: #7F8997
</style>
